import axios from "axios"
import qs from "querystring"

import { getAccessToken, getIsRefreshToken, removeTokens } from "@shared/modules"
import { accountService } from "@shared/services"

interface config {
  scheduleId: string | undefined
}

const webClientConfig = {
  scheduleId: undefined,
} as config

const webClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  transformRequest: [(data) => qs.stringify(data)],
  responseType: "json",
})

webClient.defaults.headers["Access-Control-Allow-Origin"] = "*"
webClient.defaults.headers["Authorization"] = getAccessToken() || ""
webClient.defaults.transformRequest = [(data) => qs.stringify(data)]

const EXCEPT_URLS = [
  "/account/check",
  "/statistics/days/all",
  "/statistics/cumulative/viewers",
]
const VOD_URL = ["/vods"]

// 숏폼 비회원은 refreshToken을 받지 않아 403이어도 갱신할 수 없다.
// 갱신을 시도하면 빈 refreshToken으로 요청이 나가고 만료/갱신실패 alert이 중복으로 뜬다.
// 호출부에서 처리하도록 그대로 넘긴다. (재생 페이지는 kick, 라이브 요약 모달은 alert)
// refreshToken이 있는 회원은 기존대로 갱신 후 재시도한다.
const isShortsWithoutRefreshToken = (url?: string) =>
  !!url?.startsWith("/shorts") && !getIsRefreshToken()

webClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    let originalRequest = error.config
    if (
      VOD_URL.includes(error.config.url) &&
      error.response &&
      error.response.status === 403
    ) {
      alert("로그인 후 이용가능합니다.")
    } else if (
      !EXCEPT_URLS.includes(error.config.url) &&
      !isShortsWithoutRefreshToken(error.config.url) &&
      error.response &&
      error.response.status === 403 &&
      !originalRequest._retry
    ) {
      try {
        const token = await accountService.refreshToken()

        if (!token) throw new Error("토큰값을 읽어 오지 못했습니다")

        originalRequest.headers["Authorization"] = token.accessToken

        if (originalRequest.data) {
          originalRequest.data = qs.parse(originalRequest.data)
        }

        return axios.request(originalRequest)
      } catch (error) {
        removeTokens()
        alert("사용자 정보 갱신에 실패 하였습니다.")
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  },
)

const clearHeader = (): void => {
  delete webClient.defaults.headers["Authorization"]
}

export { webClient, webClientConfig, clearHeader }
